// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.6.249",
  "gitHash": "ba94a030d112305cd93492c68e9b0900f01d9df2",
  "versionWithHash": "5.6.249-ba94a030d112305cd93492c68e9b0900f01d9df2"
};
